// const url = 'https://ancient-temple-54024.herokuapp.com'
// const url = 'http://localhost:3003'
// const url = 'http://54.229.86.20:3003'
const url = '/api/'
export default url